
import RowNode from "./RowNode";
import ColNode from "./ColNode";
import SvgNode from "./SvgNode";

import WidgetNode from "./WidgetNode";
import ButtonNode from "./ButtonNode";

import BoxNode from "./BoxNode";
import LinkNode from "./LinkNode";
import ImgNode from "./ImgNode";
import MuiTypography from './TypographyNode';
import Ellipsis from "./Ellipsis";
import IncludeNode from "./IncludeNode";
import FragmentNode from "./FragmentNode";
import IfNode from "./IfNode";
import RepeatNode from "./RepeatNode";
import ContainerNode from "./ContainerNode";
import ComponentNode from "./ComponentNode";
import Dangerously from "./Dangerously";
import Slot from "./Slot";
import TransNode from "./TransNode";
import HrNode from "./HrNode";
import StateNode from "./StateNode";
import ScrollNode, { ScrollXNode, ScrollYNode } from "./ScrollNode";


export const nodeRegistry: any = {
  ellipsis: Ellipsis,
  t: TransNode,
  state: StateNode,
  scroll: ScrollNode,
  scroll_x: ScrollXNode,
  scroll_y: ScrollYNode,
  scroll_horizontal: ScrollXNode,
  scroll_vertical: ScrollYNode,
  hr: HrNode,
  slot: Slot,
  dag: Dangerously,
  dangerously: Dangerously,
  include: IncludeNode,
  svg: SvgNode,
  fragment: FragmentNode,
  if: IfNode,
  repeat: RepeatNode,
  component: ComponentNode,
  container: ContainerNode,
  img: ImgNode,
  link: LinkNode,
  box: BoxNode,
  row: RowNode,
  col: ColNode,
  widget: WidgetNode,
  button: ButtonNode,
  typography: MuiTypography,
};

export default nodeRegistry;
